import api from 'app/shared/utils/api';
import promise from 'promise';

import DispatchConstants from 'app/shared/constants/DispatchConstants';
import SingleFamilyContractDetails from 'app/shared/model/SingleFamilyContractDetails';

const SingleFamilyEnterpriseActions = {
    getContracts() {
        return dispatch => dispatch(api.users.singleFamilyEnterprise.getContracts())
            .then((response) => {
                if (response.success && response.response) {
                    const contractsModel = response.response.contracts.map(SingleFamilyContractDetails);
                    dispatch({
                        type: DispatchConstants.SINGLE_FAMILY_SET_CONTRACTS,
                        payload: {
                            contracts: contractsModel,
                        },
                    });
                    return contractsModel;
                }
                return promise.reject(response.error);
            });
    },
    setCustomerId(listingAlias, customerId) {
        return dispatch => dispatch(api.users.singleFamilyEnterprise.setCustomerId(listingAlias, customerId))
            .then((response) => {
                if (response.success) {
                    return { success: true };
                }
                return promise.reject(response.error);
            });
    },
};

export default SingleFamilyEnterpriseActions;
